import React from 'react'
import { BarsSlider, Bars } from '../components';


const Home = () => {
  return (
    <>
        <BarsSlider/>
        <Bars/>
    </>
  )
}

export default Home